'use strict';
const angular = require('angular');

export class ConnectedAccountChargesComponent {
  /*@ngInject*/
  constructor(StripeService, DTOptionsBuilder, WebAccessService) {
    this.StripeService = StripeService;
    this.DTOptionsBuilder = DTOptionsBuilder;
    this.WebAccessService = WebAccessService;

    this.mapContact = {};
    this.isLoading = true;
  }

  loadData() {
    if (this.config.accountId && this.config.contactEmail) {
      this.StripeService.getPaymentsByContact({id: this.config.accountId, email: this.config.contactEmail}, data => {
        this.data = data;
        this.isLoading = false;
      })
    } else {
      this.StripeService.getPayments({id: this.config.accountId}, data => {
        this.data = data;
        this.isLoading = false;
      })
    }
  }

  $onInit() {
    this.config = this.resolve.config;

    this.title = this.config.title || 'Connected Account Payments';

    this.dtOptions = this.DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('responsive', true)
      .withOption('buttons',[{
        extend: 'excel',
        title: "Payments " + this.config.name
      },{
        extend: 'csv',
        title: "Payments " + this.config.name
      },{
        title: "Payments " + this.config.name,
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Payments " + this.config.name
      }]);

    if (!this.config.contactEmail) {
      this.WebAccessService.query(data => {
        data.forEach(wa => this.mapContact[wa._id] = wa);
        this.loadData();
      }, err => {
        console.log("Could not retrieve website access.")
      });
    } else {
      this.loadData()
    }
  };

  ok() {
    this.close();
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.connectedAccountCharges', [])
  .component('connectedAccountCharges', {
    template: require('./connected-account-charges.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ConnectedAccountChargesComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/connected-account-charges/connected-account-charges.component.js